import { Component, inject, Input } from '@angular/core';
import { CartItems } from '@shared/classes/my-orders';
import { GlobalHandlerService } from '@core/services/global-handler.service';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppService } from '@core/services/app.service';

import { TranslateModule } from '@ngx-translate/core';
import { SubscriptionTicketItemComponent } from './subscription-ticket-item/subscription-ticket-item.component';
import { SharedModule } from '@shared/shared.module';


interface SubscriptionTickets {
  content: CartItems[];
}

@Component({
  selector: 'app-subscription-ticket',
  templateUrl: './subscription-ticket.component.html',
  styleUrls: ['./subscription-ticket.component.scss'],
    imports: [SharedModule, SubscriptionTicketItemComponent, ReactiveFormsModule, TranslateModule]
})
export class SubscriptionTicketComponent {
  private appService = inject(AppService);
  private globalHandlerService = inject(GlobalHandlerService);

  filterSupportId: FormControl = new FormControl(null, [Validators.required]);
  supportId: string;
  subscriptionCartItems: CartItems[] = null;
  searchCartItemsError: boolean = false;
  expSubIdx: number = -1;
  showLoading: boolean = false;

  @Input() subscriptionType: string;

  onSearchSubscriptionTicket(onRefresh: boolean = false) {
    if (!onRefresh) {
      if (this.filterSupportId.invalid) {
        return;
      }
      this.subscriptionCartItems = null;
      this.supportId = this.filterSupportId.value;
    }
    this.showLoading = true;
    this.searchCartItemsError = false;
    const params = { supportId: this.supportId };
    this.appService.getElement('selling/web/subscriptiontickets/search', params).subscribe(
      (response: SubscriptionTickets) => {
        this.showLoading = false;
        this.expSubIdx = onRefresh ? this.expSubIdx : -1;
        if (response && response.content) {
          this.subscriptionCartItems = response.content;
          if (this.subscriptionCartItems.length === 1 && !onRefresh) {
            this.onSetExpandedItemIdx(0);
          }
        } else {
          this.subscriptionCartItems = [];
        }
      }, (error) => {
        this.showLoading = false;
        this.globalHandlerService.showError(error);
        this.searchCartItemsError = true;
      }
    )
  }

  onSetExpandedItemIdx(subscriptionIdx: number) {
    this.expSubIdx = this.expSubIdx === subscriptionIdx ? -1 : subscriptionIdx;
  }

  trackBySubscription(index, subscription: CartItems) {
    return subscription.resourceId;
  }
}
